import React, { type FC, useState } from 'react'
import { type RouteComponentProps, useNavigate } from '@reach/router'
import { t } from 'i18next'
import { Button, AlertDialog, Icon } from '@awell-health/design-system'
import { useDeletePatient } from '../../../hooks/useDeletePatient'
import { isNil } from 'lodash'

interface SettingsTabProps {
  patientId: string
  patientName: string
}

export const SettingsTab: FC<RouteComponentProps<SettingsTabProps>> = ({ patientId, patientName }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const { deletePatient } = useDeletePatient()

  const handleDelete = async () => {
    if (isNil(patientId)) return
    const success = await deletePatient(patientId)
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    if (success) navigate(`/patients`)
  }

  const handleModalClose = () => {
    setModalOpen(false)
  }

  return (
    <>
      <div className="rounded-xl border p-5">
        <Button onClick={() => setModalOpen(true)} variant="error">
          {t('delete_patient')}
        </Button>
      </div>
      {modalOpen && (
        <AlertDialog
          title={t('delete_patient_heading', {
            patientName
          })}
          text={t('delete_patient_confirmation', {
            patientName
          })}
          button={{
            label: t('delete'),
            buttonVariant: 'error',
            buttonAction: handleDelete
          }}
          secondaryButton={{
            label: t('cancel'),
            buttonAction: handleModalClose
          }}
          icon={
            <div className="w-11 h-11 rounded-full bg-red-100 flex items-center justify-center">
              <div className="w-9 h-9 rounded-full bg-red-200 flex items-center justify-center">
                <Icon className="fill-red-600" icon="RiAlertFill" size={24} />
              </div>
            </div>
          }
          onClose={handleModalClose}
        />
      )}
    </>
  )
}

SettingsTab.displayName = 'SettingsTab'
